<template>
    <div>
      <Nav className="navbar navbar-default navbar-mobile navbar-fixed light bootsnav" />
      <PicBanner title="" desc="" bgImg="/img/84054474.jpg" />
      <ContactInfo />
      <Footer :functions="meta.active_functions" />
      <FollowModal />
      <SubscribeModal />
    </div>
  </template>
  <script>
  // @ is an alias to /src
  import Nav from '@/components/Nav.vue'
  import PicBanner from '@/components/PicBanner.vue'
  import ContactInfo from '@/components/ContactInfo.vue'
  import Footer from '@/components/Footer.vue'
  import FollowModal from '@/components/FollowModal.vue'
  import SubscribeModal from '@/components/SubscribeModal.vue'
  
  export default {
    name: 'contact',
    props: ['meta'],
    components: {
      Nav,
      PicBanner,
      ContactInfo,
      Footer,
      FollowModal,
      SubscribeModal
    },
    created: function() {
      //console.log(this.$i18n.locale)
    }
  }
  </script>